import React, {Component} from "react";
import Carousel from "nuka-carousel";

import styles from  "./HomeSlider.module.scss";

import emmaus from "./img/emmaus-web.jpg";
import ipaje from "./img/ipaje-web.jpg";
import handiscover from "./img/handiscover-web.jpg";
import blanccambouis from "./img/blanccambouis-web.png";
import ccilyon from "./img/ccilyon-web.png";

class HomeSlider extends Component {

    render() {

        var Decorators = [
          {
              component: React.createClass({
                render() {
                  return (
                    <i
                        className={`icon-chevron-thin-left ${styles.sliderArrow}`}
                        aria-hidden="true"
                        onClick={this.props.previousSlide}
                    >
                    </i>

                  )
                }
              }),
              position: 'CenterLeft',
              style: {
                padding: -50
              }
          },
          {
              component: React.createClass({
                render() {
                  return (
                    <i
                        className={`icon-chevron-thin-right ${styles.sliderArrow}`}
                        aria-hidden="true"
                        onClick={this.props.nextSlide}
                    >
                    </i>
                  )
                }
              }),
              position: 'CenterRight',
              style: {
                padding: -50
              }
          },

        ];

        return (
            <Carousel decorators={Decorators} autoplay={true} wrapAround={true} >
              <div className={`text-center ${styles.slideritem}`}>
                <h3>Blanc Cambouis</h3>
                <img src={blanccambouis} className="img-fluid" alt="Site E-Commerce Blanc Cambouis"/>
                <blockquote className={`${styles.blockquote}`}>
                  <p>Réalisation du <a href="/e-commerce" title="Site E-Commerce">site E-Commerce</a> de la marque du designer de meuble vintage Blanc Cambouis. Vous pouvez entièrement choisir les options de votre meuble et les visualiser instantannément sur votre PC, Tablette ou Smartphone en 3D.</p>
                  <p>
                    Symfony - Architecture orientée service - Web service - Responsive - 3D
                  </p></blockquote>
              </div>

              <div className={`text-center ${styles.slideritem}`}>
                <h3>CCI Lyon Métropole</h3>
                <img src={ccilyon} className="img-fluid" alt="Portail Web CCI Lyon"/>
                <blockquote className={`${styles.blockquote}`}>
                  <p>Intégration de l'ensemble du <a href="/portail-web-collaboratif" title="Réalisation de portail web">portail Web métier</a> de la CCI de Lyon métropole aux couleurs de la nouvelle charte graphique des CCI.</p>
                  <p>
                    HTML - CSS - Javascript - Responsive
                  </p></blockquote>
              </div>

              
              <div className={`text-center ${styles.slideritem}`}>
              <h3>Synlab Labco</h3>
                <img src={emmaus} className="img-fluid" alt="Application Web Labco"/>
                <blockquote className={`${styles.blockquote}`}>
                  <p>Développement d'une <a href="/application-web" title="Création d'application Web">application web</a> et mobile connectée au système d'information de la société Labco (160 laboratoires en Europe), dédiée à la gestion et au suivi des prélèvements d'échantillons des patients réalisés par les infirmières à domicile.</p>
                  <p>
                    Symfony 2 - Architecture orientée service - Web service - iOS/Android
                  </p></blockquote>
              </div>


              <div className={`text-center ${styles.slideritem}`}>
                <h3>IPAJE</h3>
                <img src={ipaje} className="img-fluid" alt="Application Web Ipaje"/>
                <blockquote className={`${styles.blockquote}`}>
                  <p>Création, pour le compte de la société Ipaje, d'une <a href="/application-web" title="Une Application Web sous forme de serious Game">application web responsive</a> de simulation de gestion d'entreprise qui simule la vie et les comptes d'entreprises, en compétition de marché, destinée à la formation pour les salariés ou les étudiants.</p>
                  <p>Symfony 2 - SAAS - Responsive</p></blockquote>
              </div>

              <div className={`text-center ${styles.slideritem}`}>
              <h3>Emmaus International</h3>
                <img src={emmaus} alt="Application Web Emmaus" className="img-fluid"/>
                <blockquote className={`${styles.blockquote}`}>
                  <p>Le <a href="/application-web" title="Application web et serious game">serious game</a> "Dans les pas de l'abbé Pierre" de l'association Emmaüs International vous propose à travers un parcours, de découvrir les différents combats de l'abbé Pierre. Votre choix d'un combat par thématique vous permettra de d'établir votre profil militant.</p>
                  <p>Symfony 3</p></blockquote>
              </div>

              <div className={`text-center ${styles.slideritem}`}>
                <h3>DOWiNO</h3>
                <img src={handiscover} alt="Application Web sous forme de serious game Handiscover" className="img-fluid"/>
                <blockquote className={`${styles.blockquote}`}>
                  <p>Le jeu Web Handiscover a été conçu afin de faire évoluer le regard sur le handicap de façon ludique et originale. A travers 3 niveaux, le joueur est amené à découvrir 12 innovations révolutionnant le quotidien des personnes en situation de handicap et ce, aux quatre coins du monde. Lorsqu’il découvre une innovation, il doit aussi répondre à 2 questions en lien avec le handicap abordé et cumuler un maximum de points.</p>
                  <p>Symfony 2 - Node.js</p></blockquote>
              </div>

              {/* <div className={`text-center ${styles.slideritem}`}>
                <h3>myooh</h3>
                <img src="images/myooh.png" className="img-fluid" alt="Portail métier d'affichage digital"/>
                <blockquote className={`${styles.blockquote}`}>
                  <p>Réalisation d'un portail Web métier de gestion des flux de données, triés par grand module métier et organisés pour l'affichage digitale. Cette application permet d'enrichir à la volée des flux d'informations à destination de divers moniteurs.</p>
                  <p>Symfony 3</p></blockquote>
              </div> */}

            </Carousel>
        );
    }
}

export default HomeSlider;



// WEBPACK FOOTER //
// ./src/components/HomeSlider/HomeSlider.jsx